import { TranslateService } from '@ngx-translate/core';
import { CompanyListDTO } from './../models/company.model';
import { PortaleFEService } from './portaleFE.service';
import { GlobalService } from './global.service';
import { SPIDUser } from './../models/SPIDUser.model';
import { DialogService } from './dialog.service';
import { JsonResult } from './../models/helper.model';
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class SPIDService {

  public constructor(private http: HttpClient, private portaleFEService: PortaleFEService, private translate: TranslateService) { }

  getSPIDUrlLogin() {
    let url = environment.apiFullUrl + '/SPID/SPIDLogin' + "?ClientID=E1846FBA-641B-4663-973C-6CED1D778EF9";
    this.http.get<JsonResult>(url).toPromise().then((res) => {
      window.open(JSON.parse(JSON.stringify(res.Value)), "_self");
    }).catch((err) => {
      DialogService.Error(err.message);
    });
  }

  getSPIDUser(ID: string, key: string): Promise<SPIDUser> {
    return this.http.get<SPIDUser>(environment.apiFullUrl + '/SPID/GetSPIDUser/' + ID + '/' + key + "?ClientID=E1846FBA-641B-4663-973C-6CED1D778EF9").toPromise();
  }

  updateCompanyFromSPID(SPIDUser: SPIDUser): Promise<CompanyListDTO> {
    return this.http.post<CompanyListDTO>(environment.apiFullUrl + '/SPID/UpdateCompanyFromSPID', SPIDUser).toPromise();
  }

  SPIDAuth(sessionID: string, sessionKey: string, portaleFEWorkflow: boolean = true) {
    if (sessionID != null && sessionKey != null) {
      GlobalService.authSpidOk=true;
      DialogService.Confirm("Il/la sottoscritto/a, come riconosciuto/a tramite autenticazione SPID (Identità Digitale), dichiara di essere munito/a dei poteri necessari per la sottoscrizione del contratto di erogazione del servizio di fatturazione elettronica e conservazione a norma delle fatture elettroniche. I dati inseriti in fase di registrazione NON saranno più modificabili", () => {
        this.getSPIDUser(sessionID, sessionKey).then(async (res) => {
          let SPIDUser = res;
          SPIDUser.ID = GlobalService.getUsedCompany();
          let updatedCompany = await this.updateCompanyFromSPID(SPIDUser);
          //Aggiorno l'azienda con i nuovi campi
          GlobalService.setCurrentCompany(updatedCompany);
          //Faccio poi partire il workflow del Portale FE
          GlobalService.authSpidOk=false;
          if (portaleFEWorkflow == true)
            this.portaleFEService.PortaleFEAuth();
        })
      }, true);
    }
  }

}
